<template>
  <v-app>
    <div class="app-div">
      <MainLayout />
      <StackingSnackbar />
    </div>
  </v-app>
</template>

<script setup lang="ts">
  import StackingSnackbar from '@components/shared/StackingSnackbar.vue';
  import { useTheme } from '@composables/useTheme';
  import MainLayout from '@layouts/MainLayout.vue';
  import { onMounted } from 'vue';

  const { loadTheme } = useTheme();

  onMounted(() => {
    loadTheme();
  });
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #003882;
  background-color: #e2eaef;
}

.app-div {
  min-height: 100vh;
  background-color: #e2eaef;
  overflow-x: hidden;
}

#message_div {
  bottom: 10%;
  position: absolute;
  left: 20%;
  width: 40%;
}
</style>
